import React, { useCallback, useMemo, useEffect } from "react";
import CategoryScraperForm from "./Category.jsx"
import ServiceForm from "./ServceForm";
import QRCodeGenerator from "./QRCodeGenerator";
import AdsPosterManager from "./AdPosterManager";
import LogoHeaderUploader from "./LogoHeaderUploader.jsx";
import FreeQuery from "./FreeQuery.jsx";
import { useState } from "react";
import { submitTerminalConfigs, submitTerminalConfigsImages, deleteTerminal } from "../../Services/terminal.js";
import { useTerminalConfig } from "../../Path/NewTerminalConfigs.jsx";
import NewTerminalForm from "./NewTerminalForm.jsx";
import { useTranslation } from "react-i18next";
import DeleteConfirmationModal from "../../common/DeleteConfirmationModal.jsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchImageAsBlob } from "../../Services/mediaUtils.js";
export const base64ToFile = (base64String) => {
    const isBase64DataUrl = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+)?;base64,/.test(base64String);
    if (isBase64DataUrl) {
        const arr = base64String.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const extension = mime.split('/')[1] || 'png'; // default to png
        const filename = `file_${Date.now()}.${extension}`;
        const bstr = atob(arr[1]);
        const u8arr = new Uint8Array(bstr.length);

        for (let i = 0; i < bstr.length; i++) {
            u8arr[i] = bstr.charCodeAt(i);
        }

        return new File([u8arr], filename, { type: mime });
    }
    return base64String;
}

const TerminalForm = ({ refetch }) => {
    const { terminalConfig, setTerminalConfig } = useTerminalConfig();
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loader, setLoader] = useState(false)
    const { t } = useTranslation();

    const navigate = useNavigate();
    useEffect(() => {
        if (success) {
            const timer = setTimeout(() => {
                setSuccess("");
            }, 3000);

            return () => clearTimeout(timer); // Cleanup if component unmounts
        }
    }, [success]);
    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError("");
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);
    const handleSubmit = async () => {
        try {
            setLoader(true)
            const res = await submitTerminalConfigs(terminalConfig.terminalId, {
                qrIds: terminalConfig.qrIds,
                adIds: terminalConfig.adIds,
                query: terminalConfig.query,
                serviceIds: terminalConfig.serviceIds,
                qrCodeLabel: terminalConfig.qrCodeLabel,
                serviceLabel: terminalConfig.serviceLabel,
                categoryIds: terminalConfig.selectedCategoriesIds.map((categ) => categ.id),
                serviceIds: terminalConfig.selectedServices.map((serv) => serv.id)
            });
            const formData = new FormData();
            if (terminalConfig.logo_url) {
                if (typeof terminalConfig.logo_url === "string" && !terminalConfig.logo_url.startsWith("https")) {
                    const file = base64ToFile(terminalConfig.logo_url);
                    formData.append('logo_url', file);
                } else {
                    const blobLogo = await fetchImageAsBlob(base64ToFile(terminalConfig.logo_url));
                    formData.append('logo_url', blobLogo);
                }
            }
            if (terminalConfig.header_url) {
                if (typeof terminalConfig?.header_url === "string" && !terminalConfig?.header_url.startsWith("https")) {
                    const file = base64ToFile(terminalConfig.header_url);
                    formData.append('header_url', file);
                } else {
                    const blobHeader = await fetchImageAsBlob(base64ToFile(terminalConfig.header_url));
                    formData.append('header_url', blobHeader);
                }
            }
            if (terminalConfig.background_url) {
                if (typeof terminalConfig.background_url === "string" && !terminalConfig.background_url.startsWith("https")) {
                    const file = base64ToFile(terminalConfig.background_url);
                    formData.append('background_url', file);
                } else {
                    const blobBg = await fetchImageAsBlob(base64ToFile(terminalConfig.background_url));
                    formData.append('background_url', blobBg);
                }
            }
            let imageRes;
            // if ([...formData.entries()].length > 0) {
            imageRes = await submitTerminalConfigsImages(terminalConfig.terminalId, formData);
            // }
            if (res.data.status === "success" || imageRes?.data?.status === "success") {
                setSuccess(t("terminal_confiq_success"));
                refetch();
            }
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const message = error.response?.data?.message || t("terminal_error");
                setError(message);
            } else {
                console.error("Unexpected error:", error);
                setError(t("terminal_error"));
            }
        }
        finally {
            setLoader(false)
        }
    }
    const handleQrTitleChange = (e) => {
        setTerminalConfig((prev) => ({
            ...prev,
            qrCodeLabel: e.target.value
        }));
    }
    const handleServiceTitle = (e) => {
        setTerminalConfig((prev) => ({
            ...prev,
            serviceLabel: e.target.value
        }))
    }
    const handleDelete = useCallback(async () => {
        const response = await deleteTerminal(terminalConfig.terminalId);
        if (response.data.status === "success") {
            navigate("/terminalDashboard?create=true");
        }
    })

    const isDisabled = useMemo(() => {
        return !(
            (Array.isArray(terminalConfig?.adIds) && terminalConfig?.adIds?.length )||
            terminalConfig?.logo_url ||
            terminalConfig?.qrCodeLabel ||
            terminalConfig?.serviceLabel ||
            terminalConfig?.header_url ||
            terminalConfig?.background_url ||
            terminalConfig?.selectedCategoriesIds.length > 0 ||
            terminalConfig?.selectedServices.length > 0
        );
    }, [terminalConfig]);


    const buttonClass = useMemo(() => {
        return `rounded-xl py-2 px-6 font-bold self-center mt-4 w-fit transition text-white ${isDisabled
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-green-500 hover:bg-green-600 cursor-pointer"
            }`;
    }, [isDisabled]);

    const handleCloseModal = useCallback(() => {
        setShowModal(false)
        refetch()
    }, [refetch])

    return <div className="p-6 m-auto flex flex-col">
        <h4 className="text-3xl font-bold text-center text-white">{terminalConfig?.name} {t("terminnal_config_title")}</h4>
        <div className="mb-8 mt-2 gap-2 flex flex-row justify-center align-center">
            <a href={`${window.location.origin}/TerminalById/${terminalConfig.terminalId}`} className="text-md font-bold text-center text-blue-600 underline self-center" target="_blank"
                rel="noopener noreferrer">{t("check_your_public_url")}</a>
            <button className="text-white border py-1 px-4 rounded" onClick={() => setShowModal(true)}>{t("edit_terminal_title")}</button>
            <button className="text-white border py-1 px-4 rounded" onClick={() => setDeleteModal(true)}>{t("delete_terminal")}</button>

        </div>

        {terminalConfig.template !== "C" && <>
            <LogoHeaderUploader />
            <div className="h-1 w-full bg-white self-center my-4"></div>
        </>}
        {terminalConfig.template !== "C" &&
            <>

                <CategoryScraperForm />
                <div className="h-1 w-full bg-white self-center my-4"></div>
            </>}
        {terminalConfig.template !== "C" &&
            <>
                <div className="flex flex-col">
                    <label className="mt-2 text-xl font-semibold mb-2 text-white">{t("service_section_display_title")}</label>
                    <input type="text" className="flex-1 py-2 px-4 border border-gray-300 rounded max-w-sm" required placeholder={t("enter_service_title")} value={terminalConfig?.serviceLabel} onChange={handleServiceTitle} />
                    <ServiceForm />
                </div>
                <div className="h-1 w-full bg-white self-center my-4"></div>
            </>
        }
        {terminalConfig.template !== "C" &&
            <div className="flex flex-col">
                <label className="mt-2 text-xl font-semibold mb-2 text-white">{t("qr_section_display_title")}</label>
                <input type="text" className="flex-1 py-2 px-4 border border-gray-300 rounded max-w-sm" required placeholder={t("enter_qr_title")} value={terminalConfig?.qrCodeLabel} onChange={handleQrTitleChange} />
            </div>
        }
        {terminalConfig.template !== "C" && <>
            <QRCodeGenerator />
            <div className="h-1 w-full bg-white self-center my-4"></div>
        </>}
        <AdsPosterManager />
        {terminalConfig.template === "C" && <p className="text-bold text-md mt-4 text-white"><span className="text-2xl">{t("note")} - </span>{t("ad_section_info")}</p>}
        <div className="h-1 w-full bg-white self-center my-4"></div>
        {terminalConfig.template !== "C" && <FreeQuery />}
        {success && <div className="top-4 fixed right-2 p-3 bg-green-100 text-green-800 rounded-md text-xs">{success}</div>}
        {error && <div className="top-4 fixed right-2 p-3 bg-red-100 text-red-800 rounded-md text-xs">{error}</div>}
        <button
            onClick={handleSubmit}
            disabled={isDisabled}
            className={buttonClass}
        >
            {loader ? (
                <div className="w-5 h-5 rounded-full border-2 border-white border-t-transparent animate-spin"></div>
            ) : (
                t("submit_query")
            )}
        </button>
        <NewTerminalForm open={showModal} close={() => handleCloseModal()} submitRequest={() => { }} isEditing={true} terminalData={terminalConfig} />
        <DeleteConfirmationModal open={deleteModal} title={t("delete_terminal")} message={t("delete_terminal_confirmation")} confirmText={t("delete")} onConfirm={handleDelete} cancelText={t("cancel")}
            onCancel={() => setDeleteModal(false)} />
    </div>
}

export default TerminalForm;